const  seriesClassColor = {
    normal: ["#3574dc", "#b293ee"],
    pale: ["#86A6DC", "#F2D3FF"]
};
const  seriesPlayColor = {
    normal: ["#3474dc", "#B6A2DE", "#5AB1EF", "#A1D852", "#EBD834", "#DA7937", "#2FC7C9", "#548135", "#FFB968", "#F5A9E1", "#FE9A2E", "#15DF8E", "#F26DDC"],
    pale: ["#86A6DC", "#F2D3FF", "#94E5FD", "#C1D7A0", "#C6BF80"]
};

const seriesTodayColor = {
    normal:["#FFC100", "#A5A5A5", "#ED7D32", "#5B9AD4"]
};

module.exports = {
    seriesClassColor,
    seriesPlayColor: seriesPlayColor,

    seriesPlayChart: [
    ],
    seriesPlayAppConnectChart: [
        { name: "앱", field: "connectApp", stack: "base", showSum: true, option: { itemStyle: { color: "#60d7c5" } } },
        { name: "웹", field: "connectWeb", stack: "base", showSum: true, option: { itemStyle: { color: "#b9ed4a" } } },
    ],
    seriesPlayPlatformConnectChart: [
        { name: "Android", field: "connectAndroid", stack: "base", showSum: true, option: { itemStyle: { color: "#60d7c5" } } },
        { name: "iOS", field: "connectIos", stack: "base", showSum: true, option: { itemStyle: { color: "#b9ed4a" } } },
    ],

    seriesAgeChart: [
        {name: "만 3세", field: 1, stack: "base", showSum: "true", option: { itemStyle: {color: seriesTodayColor.normal[0]}}},
        {name: "만 4세", field: 2, stack: "base", showSum: "true", option: { itemStyle: {color: seriesTodayColor.normal[1]}}},
        {name: "만 5세", field: 3, stack: "base", showSum: "true", option: { itemStyle: {color: seriesTodayColor.normal[2]}}},
        {name: "혼합", field: 123, stack: "base", showSum: "true", option: { itemStyle: {color: seriesTodayColor.normal[3]}}}
    ],

    seriesTodayRunChart: [
        { name: "당일실행", field: "todayRun", stack: "base", showSum: true, option: { itemStyle: { color: seriesTodayColor.normal[3] } } },
        { name: "당일제외실행", field: "notTodayRun", stack: "base", showSum: true, option: { itemStyle: { color: seriesTodayColor.normal[1] } } },
        { name: "모두보기/보관함", field: "etc", stack: "base", showSum: true, option: { itemStyle: { color: seriesTodayColor.normal[2] } } },
    ],

    seriesTodayStampChart: [
        { name: "1회~5회", field: "five", stack: "base", showSum: true, option: { itemStyle: { color: seriesTodayColor.normal[0] } } },
        { name: "6회~10회", field: "ten", stack: "base", showSum: true, option: { itemStyle: { color: seriesTodayColor.normal[1] } } },
        { name: "11회~15회", field: "fifty", stack: "base", showSum: true, option: { itemStyle: { color: seriesTodayColor.normal[2] } } },
        { name: "16회~20회", field: "twenty", stack: "base", showSum: true, option: { itemStyle: { color: seriesTodayColor.normal[3] } } },
    ],

    seriesActivityType: [
        { id: 1, service: "flyeng", name: "영상(교실영어)", type: "path", basePath: "video"},
        { id: 2, service: "flyeng", name: "일반 영상", type: "file", basePath: "book"},
        { id: 3, service: "flyeng", name: "액티비티", type: "file", basePath: "activity"},
        { id: 4, service: "flyeng", name: "AI", type: "ai", basePath: "ai"},
        { id: 1, service: "momo", name: "영상", basePath: "video"},
        { id: 2, service: "momo", name: "액티비티", basePath: "activity"},
        { id: "S", service: "tomonote", name: "자료"},
        { id: "M", service: "tomonote", name: "멀티"},
        { id: "H", service: "tomonote", name: "가족연계"},
        { id: "C", service: "song", name: "동요"},
        { id: "D", service: "audio", name: "오디오"},
        { id: null, service: "audio", name: "오디오"},
    ]
};